import { render, staticRenderFns } from "./VideoListVertical.vue?vue&type=template&id=f7bd223c&scoped=true&"
import script from "./VideoListVertical.vue?vue&type=script&lang=js&"
export * from "./VideoListVertical.vue?vue&type=script&lang=js&"
import style0 from "./VideoListVertical.vue?vue&type=style&index=0&id=f7bd223c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bd223c",
  null
  
)

export default component.exports